import cloneDeep from 'lodash/cloneDeep';

import {
  MIN_TABLE_COLUMN_WIDTH,
  NEW_TABLE_COLUMN_WIDTH,
  Table,
  TableCell,
  TableRow,
} from './table.constants';

function adjustWidths(
  widths: number[],
  specificIndex: number,
  direction: 'right' | 'left'
) {
  const newWidths = [...widths];
  const insertColumnAtIndex =
    direction === 'right' ? specificIndex + 1 : specificIndex;
  const adjustColumnIndex =
    direction === 'right' ? specificIndex : specificIndex - 1;

  if (
    adjustColumnIndex === -1 ||
    (adjustColumnIndex > -1 &&
      newWidths[adjustColumnIndex] - NEW_TABLE_COLUMN_WIDTH <
        NEW_TABLE_COLUMN_WIDTH)
  ) {
    for (let i = 0; i < widths.length; i++) {
      if (newWidths[i] > NEW_TABLE_COLUMN_WIDTH + MIN_TABLE_COLUMN_WIDTH) {
        newWidths[i] -= NEW_TABLE_COLUMN_WIDTH;
        break;
      }
    }
  } else {
    newWidths[adjustColumnIndex] -= NEW_TABLE_COLUMN_WIDTH;
  }

  newWidths.splice(insertColumnAtIndex, 0, NEW_TABLE_COLUMN_WIDTH);
  return newWidths;
}

export function addToRight(table: Table, index: number) {
  const updatedTableData = cloneDeep(table);

  const tableRow: TableCell = {
    value: {},
    __typename: 'TableComponentCell',
  };
  updatedTableData.rows.forEach(row => {
    row.cells.splice(index + 1, 0, tableRow);
  });

  updatedTableData.columnWidths = adjustWidths(
    updatedTableData.columnWidths,
    index,
    'right'
  );
  return updatedTableData;
}

export function addToLeft(table: Table, index: number) {
  const updatedTableData = cloneDeep(table);

  updatedTableData.rows.forEach(row => {
    row.cells.splice(index, 0, {
      value: {},
      __typename: 'TableComponentCell',
    });
  });

  updatedTableData.columnWidths = adjustWidths(
    updatedTableData.columnWidths,
    index,
    'left'
  );
  return updatedTableData;
}

export function removeColumn(table: Table, colIndex: number) {
  const updatedTableData = cloneDeep(table);

  updatedTableData.rows.forEach(row => {
    row.cells.splice(colIndex, 1);
  });

  const removed = updatedTableData.columnWidths.splice(colIndex, 1);
  if (updatedTableData.columnWidths[colIndex]) {
    updatedTableData.columnWidths[colIndex] =
      updatedTableData.columnWidths[colIndex] + removed[0];
  } else {
    updatedTableData.columnWidths[colIndex - 1] =
      updatedTableData.columnWidths[colIndex - 1] + removed[0];
  }
  return updatedTableData;
}

export function canShowRemoveColumn(rows: TableRow[]) {
  return rows[0]?.cells?.length > 1;
}
